import React from 'react';
import { CopyItem, InfoItem, InfoItemLabel, InfoItemsWrapper, InfoItemValue } from '@/common/components/validClaimForm/ValidClaimForm.styled';
import Icon from '@/common/components/Icon';
import { ButtonsWrapper, Title, Wrapper } from './refundDetails.styles';
import ActionButton from '@/common/components/buttons/ActionButton';
import { Colors } from '@/common/colors/colors';
import Input from '@/common/components/Input';
import SelectInput from '@/common/components/SelectInput';
import { REFUND_REASONS } from '@/common/constants/refunds';
import { EDITABLE_FIELD, getFields } from '../../helpers/getFields';

const RefundDetails = ({ hook }) => {
	const {
		handleCopyItem,
		selectedRefund,
		editedAmount,
		setEditedAmount,
		editedReason,
		setEditedReason,
	} = hook;

    const fields = getFields(selectedRefund, editedAmount, editedReason);

    return (
		<Wrapper>
			<Title>Refund Details</Title>
			<InfoItemsWrapper>
                {fields.map((field) => (
                    <InfoItem key={field.label}>
                        <InfoItemLabel>{field.label}</InfoItemLabel>
                        {!field.editable && (
                            <InfoItemValue cursor='pointer' onClick={() => handleCopyItem(field.value)}>
                                <CopyItem >{field.value ?? 'N/A'}</CopyItem>
                                <Icon name='copy' />
                            </InfoItemValue>
                        )}
                        {field.editable === EDITABLE_FIELD.AMOUNT && (
                            <Input
                                type='number'
                                min={0}
                                controlled
                                value={editedAmount}
                                onChange={(e) => setEditedAmount(e.target.value)}
                                showLabel={false}
                                inputWidth={160}
                                margin='0'
                            />
                        )}
                        {field.editable === EDITABLE_FIELD.TITLE && (
                            <SelectInput
                                showLabel={false}
                                options={REFUND_REASONS}
                                selected={editedReason}
                                setSelected={setEditedReason}
                                selectWidth={300}
                                menuPortalTarget={document.body}
                                margin='0'
                            />
                        )}
                        {field.editable && (
                            <Icon name='copy' onClick={() => handleCopyItem(field.value)} />
                        )}
                    </InfoItem>
                ))}
			</InfoItemsWrapper>
            <ButtonsWrapper>
                <ActionButton style={{ width: '100px' }} color={Colors.green} onClick={hook.handleAcceptRefund}>
                    Accept
                </ActionButton>
                <ActionButton style={{ width: '100px' }} color={Colors.red} onClick={() => hook.setConfirmationPopup(true)}>
                    Decline
                </ActionButton>
            </ButtonsWrapper>
		</Wrapper>
	);
};

export default RefundDetails;
